/**
 * Única fuente de verdad para la identidad pública de Retail Lemon.
 * Solo el dominio apex puede emitir señales de indexación; cualquier host
 * alternativo (panel, previews o despliegues temporales) debe quedar fuera.
 */
export const CANONICAL_HOST = "retaillemon.com";

export function normalizeHostname(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/:\d+$/, "").replace(/\.$/, "");
}

export function isIndexableHost(hostname: string): boolean {
  return normalizeHostname(hostname) === CANONICAL_HOST;
}

export function shouldNoindexHost(hostname: string): boolean {
  return !isIndexableHost(hostname);
}